import { ScoreDetail } from '../game-engine/plongeur';
import { ScoreDetailsTable } from '../../shared/score-details-table/score-details-table';

export const ScoreDetailsComponent: React.FC<{ scoreDetails: ScoreDetail }> = ({ scoreDetails }) => {
  return (
    <ScoreDetailsTable rows={[
      { label: 'Saltos:', value: `${scoreDetails.saltos} (base score: ${1000 * (scoreDetails.saltos + 1)})` },
      { label: 'Réception (angle):', value: `${scoreDetails.precision as number}% (multiplier x${scoreDetails.precisionMultiplier})` },
      { label: 'Position:', value: `x${scoreDetails.positionMultiplier}` },
    ]} />
  );
}
